import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Associate } from '@quorum/models/xs-resource';

export interface SelectedAssociateState extends EntityState<Associate> {}

export const associateAdapter: EntityAdapter<Associate> = createEntityAdapter<Associate>({
  selectId: (associate: Associate) => associate.id,
});
export const initialAssociateState: SelectedAssociateState = associateAdapter.getInitialState({});
